import React from 'react';

import {
  withRouter
} from 'react-router-dom';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  VodacomLogo
} from 'src/Components/Common';

import {
  tagOnExitCheckout
} from 'src/Tagging/NewCustomerTagging';

import {
  BlackButton
} from 'src/StyledComponents';

import ErrorPopup from 'src/Components/Common/ErrorPopup/ErrorPopup';

import ExitConfirmation from 'src/Components/Common/ExitConfirmation/ExitConfirmation';

import ProgressBarMobile from './ProgressBarMobile/ProgressBarMobile';

import ProgressBar from './ProgressBar/ProgressBar';

import './Header.css';

export default withRouter((props) => {

  const context = React.useContext(SalesContext);
  const [ confirmExist, setConfirmExit ] = React.useState(false);

  const exitClickHandler = () => {
    tagOnExitCheckout();
    if (props.currentPath === 'CONFIRMATION') {
      window.location.href = '/vodacom/fibre/sales/leads';
    } else {
      setConfirmExit(true);
    }
  };

  const confirmExitCancelHandler = () => {
    setConfirmExit(false);
  };

  const confirmExitOkayHandler = () => {
    setConfirmExit(false);
    // To delete the new customer details
    context.setVettingDetails(null);
    context.setFileUploadId(null);
    context.setFileUploadBankStatement(null);
    context.setFileUploadSaWorkPermit(null);
    context.setIsUnemployed(false);
    props.history.push('/cloud/fibre/sales/deliveryAddress');
  };

  const errorPopupCancleClickHandler = () => {
    context.setNewCustomerErrorObject(null);
  };

  const errorPopupOkayClickHandler = () => {
    context.setNewCustomerErrorObject(null);
  };

  const progressBarData = [
    {
      path: 'CREDIT-VETTING',
      title: 'Credit vetting',
      status: 'PENDING',
      value: 1
    },
    {
      path: 'UPLOAD-DOCUMENTS',
      title: 'Upload documents',
      status: 'PENDING',
      value: 2
    },
    {
      path: 'REVIEW-ORDER',
      title: 'Review order',
      status: 'PENDING',
      value: 3
    },
    {
      path: 'CONFIRMATION',
      title: 'Order confirmation',
      status: 'PENDING',
      value: 4
    }
  ];

  const existingCustomerprogressBarData = [
    {
      path: 'EMPLOYERDETAILS',
      title: 'Review Order',
      status: 'PENDING',
      value: 1
    },
    {
      path: 'SUCCESS',
      title: 'Order confirmation',
      status: 'PENDING',
      value: 2
    }
  ];

  const generateProgressBarData = () => {

    const array = context?.isUserExisting ? existingCustomerprogressBarData  : progressBarData;

    const currentProgressItem = array?.find(
      (e) => e.path === props.currentPath
    );
    if (!currentProgressItem) {
      return array;
    }

    return array.map((item) => {
      if (item.value === currentProgressItem.value) {
        item.status = 'IN_PROGRESS';

        return item;
      }

      item.status =
        item.value < currentProgressItem.value ? 'COMPLETE' : 'PENDING';

      return item;
    });
  };

  const exitButtonTitleWeb =
    props.currentPath === 'CONFIRMATION' ? 'Go home' : 'Exit checkout';

  const exitButtonTitleMobile =
    props.currentPath === 'CONFIRMATION' ? 'Home' : 'Exit';

  return (
    <>
      <div className="new-customer-header__container">
        <VodacomLogo />

        <div className="new-customer-header__title">
          Secure checkout
        </div>

        <ProgressBar progresBarData={generateProgressBarData()} />

        <BlackButton
          onClick={exitClickHandler}
          className="new-customer-header__button">

          {exitButtonTitleWeb}
        </BlackButton>

        <BlackButton
          onClick={exitClickHandler}
          className="new-customer-header__button_mobile">

          {exitButtonTitleMobile}
        </BlackButton>

        {confirmExist && (
          <ExitConfirmation
            onCancelClick={confirmExitCancelHandler}
            onOkayClick={confirmExitOkayHandler}
            title="Are you sure you want to exit?"
            message="You will lose all of your progress."
            buttonTitles={[ 'No, cancel', 'Yes, exit' ]}
          />
        )}

        {context.newCustomerErrorObject && (
          <ErrorPopup
            onCancelClick={errorPopupCancleClickHandler}
            onOkayClick={errorPopupOkayClickHandler}
          >
            <span>
              We were unable to submit your order due to a technical glitch.
              <br />A call center agent will contact you shortly.
            </span>
          </ErrorPopup>
        )}
      </div>
      <ProgressBarMobile progresBarData={generateProgressBarData()} />
    </>
  );
});
